import classes from "./BestSellerPDP.module.css"
import Header from "../../Header/Header"
import BreadCrumb from "../../../Components/BreadCrumb/BreadCrumb"
import { useEffect, useState, useRef } from "react"
import SecondaryButton from "../../../Components/Buttons/SecondaryButton/SecondaryButton"
import FeatureCard from "./../FeatureCard/FeaturerCard"
import AboutBook from "./../AboutBook/AboutBook"
import Reviews from "./../Reviews/Reviews"
import { addBestSellerCartItem } from "../../../Store/actions/CartAction";
import Recommendations from "./../Recommendation/Recommendations";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight, faAngleLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { fetchBookById, fetchBookByTitle } from "../../../Store/actions/BestSellerBookAction";
import { useDispatch, useSelector } from "react-redux";
import Footer from "../../Footer/Footer";
import { urls } from "../../../Routes/Urls";
import LeatherType from "./../LeatherType/LeatherType";
import VariantType from "./../VariantType/VariantType"
import useScrollToTop from "../../../Hooks/useScrollToTop"
import { addWishlistItem, deleteWishlistItem } from "../../../Store/actions/WishlistAction"
import { generateUUID } from "three/src/math/MathUtils.js"
import { CartActions } from "../../../Store/Slices/CartSlice"
import { setIsOpen } from "../../../Store/Slices/ToggleSlice"
import useScreenSize from "../../../Hooks/UseScreenSize"
import { faHeart } from "@fortawesome/free-regular-svg-icons"
import { faHeart as faHeartFull } from "@fortawesome/free-solid-svg-icons"
import SEO from "../../../Components/SEO"
import Error410Page from "../../../Components/Error410Page"

const sewn = "/Assets/Images/pdp/sewn.png"
const notSprayed = "/Assets/Images/pdp/notSprayed.png"
const acidFree = "/Assets/Images/pdp/acidfree.png"
const goldPrinting = "/Assets/Images/pdp/goldFoil.png"
const goldEmbossing = "/Assets/Images/pdp/goldEmbossing.png"
const ribbonBookmark = "/Assets/Images/pdp/ribbonBookmark.png"
const marbleEndpaper = "/Assets/Images/pdp/marbleEnpaper.png"
const bestSellerRibbon = "/Assets/Images/pdp/bestSellerRibbon.svg"

const tabsData = ["About the book", "Reviews"]

const features = [
    {
        image: sewn,
        title: "Sewn Pages",
        desc: "Pages sewn not glued"
    },
    {
        image: acidFree,
        title: "Acid Free",
        desc: "Acid free natural shade paper"
    },
    {
        image: goldPrinting,
        title: "Gold Foil Printing",
        desc: "Gold Foil Printing on hubbed spine"
    },
    {
        image: goldEmbossing,
        title: "Gold Foil Embossing",
        desc: "Gold Foil embossing on frontcover"
    },
    {
        image: notSprayed,
        title: "Not Sprayed",
        desc: "Gold Foil gliding of edges are not sprayed"
    },
    {
        image: ribbonBookmark,
        title: "Ribbon Bookmark",
        desc: "leather bound book with ribbon bookmark"
    },
    {
        image: marbleEndpaper,
        title: "Marble Endpapers",
        desc: "Colored Marbled Endpapers"
    },
]

const VariantTabs = [
    {
        name: "Super Deluxe Edition",
        value: "superDeluxe"
    },
    {
        name: "Deluxe Edition",
        value: "deluxe"
    },
]

const LeatherTabs = [
    {
        name: "Genuine Leather",
        value: "realLeather"
    },
    {
        name: "Vegan Leather",
        value: "veganLeather"
    },
]

const BestSellerPDP = () => {

    const { id,name } = useParams();
    const dispatch = useDispatch();
    const history = useHistory()
    const bookData = useSelector(state => state.bestSellerBooks.book)
    const currentUser = useSelector(state => state.user.currentUser)
    const wishlist = useSelector((state) => state.wishlist.wishlistItems);
    const [showLeatherType, setShowLeatherType] = useState(false)
    const [showVariantType, setShowVariantType] = useState(false)
    const {isSmallScreen} = useScreenSize();
    const [notAvailable,setNotAvailable] = useState(false);

    const location = useLocation();
    const bookState = location.state?.bookData;
    const searchParams = new URLSearchParams(location.search)
    const [touchStart, setTouchStart] = useState(null);
    const [touchEnd, setTouchEnd] = useState(null);

    const color = searchParams.get('color');

    useEffect(() => {
        if(id && id!= "null") {
            fetchBookById(id, dispatch,setNotAvailable);
        } else {
            fetchBookByTitle(name,dispatch).then(res => {
                 const book = res;
                        if(book?.sku) {
                          if (id === 'null') {  
                            // Update URL without page reload
                            history.replace(`${urls.BESTSELLERPDP}/${book?.sku}/${name}`);
                          }
                }
            });
        }
    }, [id])

    const crumbs = [
        {
            title: "Home",
            path: "/"
        },
        {
            title: "Best Sellers",
            path: urls.BESTSELLER
        },
        {
            title: bookData?.title,
            path: `${urls.BESTSELLERPDP}/${id}/${bookData?.title_slug}`
        },
    ]

    const allColorsData = useSelector(state => state.bookColor.colors);
    const [currentPhotoIndex, setCurrentPhotoIndex] = useState(0);
    const activeVariant = VariantTabs[0];
    const [activeLeather, setActiveLeather] = useState(LeatherTabs[0]);
    const [qty, setQty] = useState(1);
    const [activeTab, setActiveTab] = useState(0);
    const [hasInitialized, setHasInitialized] = useState(false);
    const [allowedColors,setAllowedColors] = useState([]);

    const [allBestSellerColors,setAllBestSellerColors] = useState([]);
    // const allBestSellerColors = 

    useEffect(() => {
        setAllBestSellerColors(allColorsData?.filter(color => color.leatherType === activeLeather.value && color.isBestSeller === true));
    }, [allColorsData,activeLeather]);

    useEffect(() => {
        if (bookData?.title) {
            const colorEntries = Object.keys(JSON.parse(bookData?.images)).map(key => {
                const [colorName, leatherType] = key.split('_'); // Extract colorName and leatherType
                return { colorName, leatherType };
            });

            const filteredColors = allBestSellerColors?.filter((c) =>
                colorEntries.some(entry => entry.colorName === c?.colorName && entry.leatherType === c?.leatherType)
            );
    
            setAllowedColors(filteredColors);
        }
    }, [bookData, activeLeather,allBestSellerColors]);
    

    const getColor = (colorName) => {
        if(colorName) {
            const selectedColor = allowedColors?.find((color) => color?.colorName === colorName);
            if(selectedColor) {
              return selectedColor;
            } else {
              return allowedColors?.[0];
            }
        }
      }
  
    
    const [selectedColor, setSelectedColor] = useState(null);

    const imgRef = useRef(null);
    const [ribbonStyle, setRibbonStyle] = useState({});
  
    
    useEffect(() => {
        if (allColorsData?.length > 0 && activeLeather) {
            const defaultColor = allowedColors?.filter(
                color => color.leatherType === activeLeather.value && color.isBestSeller === true
            );

            if(color) {
                const paramColor = getColor(color)
                setSelectedColor(paramColor)
            } else if (bookState?.color && !hasInitialized) {
                const stateColor = getColor(bookState.color);
                setSelectedColor(stateColor);
            } else {
                setSelectedColor(defaultColor[0]);
            }
        }
    }, [allColorsData, allowedColors, activeLeather, bookState,color]);

        // Initialize images as an empty array
    const [images, setImages] = useState([]);

    useEffect(() => {
        if (images.length > 0) {
            setCurrentPhoto(images[currentPhotoIndex]);
        }
    }, [activeLeather, activeVariant, selectedColor]);

    const [currentPhoto, setCurrentPhoto] = useState(bookData?.imageLink ? bookData.imageLink[currentPhotoIndex] : "");

    useEffect(() => {
        setHasInitialized(false)
        if (bookData && bookData?.imageLink) {
            const baseImag = bookData.imageLink[0]
            setCurrentPhoto(baseImag)
        }
    }, [bookData])

    useEffect(() => {
        if (bookData && bookData?.imageLink) {
            setCurrentPhoto(bookData.imageLink[currentPhotoIndex])
        }
    }, [currentPhotoIndex])

    const handleLeftArrowClick = () => {
        const filteredImages = images?.filter(image => image && image !== "");
        if (currentPhotoIndex === 0) {
            setCurrentPhotoIndex(filteredImages?.length - 1)
        }
        else {
            setCurrentPhotoIndex(currentPhotoIndex - 1)
        }
    }

    useEffect(() => {
        if (!bookState?.color || bookState?.leatherType !== activeLeather.value || hasInitialized) {
            setCurrentPhoto(allowedColors[0]?.baseImg);
            setSelectedColor(allowedColors[0])
            setHasInitialized(true)
        }
    }, [activeLeather, activeVariant])

    const handleSetActiveLeather = (type) => {
            if(activeLeather?.value !== type?.value){
            setActiveLeather(type)
            setCurrentPhoto(allowedColors[0]?.baseImg);
            setSelectedColor(allowedColors[0])
            setQty(1)
        }
    }

    const handleRightArrowClick = () => {
        const filteredImages = images?.filter(image => image && image !== "");
        if (currentPhotoIndex === filteredImages?.length - 1) {
            setCurrentPhotoIndex(0)
        }
        else {
            setCurrentPhotoIndex(currentPhotoIndex + 1)
        }
    }

     // Minimum swipe distance (in px)
    const minSwipeDistance = 50;

    const onTouchStart = (e) => {
      setTouchEnd(null);
      setTouchStart(e.targetTouches[0].clientX);
    };
  
    const onTouchMove = (e) => {
      setTouchEnd(e.targetTouches[0].clientX);
    };
  
    const onTouchEnd = () => {
      if (!touchStart || !touchEnd) return;
      
      const distance = touchStart - touchEnd;
      const isLeftSwipe = distance > minSwipeDistance;
      const isRightSwipe = distance < -minSwipeDistance;
      
      if (isLeftSwipe) {
        handleRightArrowClick();
      }
      if (isRightSwipe) {
        handleLeftArrowClick();
      }
    };

    const handleQtyDecrease = () => {
        if (qty > 1) {
            setQty(qty - 1)
        }
    }
    const handleQtyIncrease = () => {
        setQty(qty + 1)
    }

    const getBookPrice = (bookData) => {
        let original = null;
        let discounted = null;

        if(activeLeather.value === LeatherTabs[0].value){
            original = bookData?.priceGenuine?.toFixed(2);
            discounted = bookData?.discountedPriceGenuine?.toFixed(2);
        } else if (activeLeather.value === LeatherTabs[1].value) {
            original = bookData?.priceVegan?.toFixed(2);
            discounted = bookData?.discountedPriceVegan?.toFixed(2);
        }

        return {
            original: original,
            discounted: discounted,
          };
    }

    const getVariant = () => {
        if(bookData?.variantType === "superDeluxe" || bookData?.variantType === "Super Deluxe"){
            return "superDeluxe"
        }
        else{
            return "deluxe"
        }
    }

    const getItemPrice = (bookData,leatherType) => {
        if(bookData && leatherType) {
            if(leatherType === "veganLeather") {
              return bookData?.priceVegan
            } else {
              return bookData?.priceGenuine
            }
        }
      }
    
    let selectedCurrency = "USD";
    if (currentUser?.id) {
        selectedCurrency = currentUser?.preferredCurrency ? currentUser?.preferredCurrency : "USD";
    } else {
        const storedCountry = localStorage.getItem("selectedCountry");
        if (storedCountry) {
            const parsedCountry = JSON.parse(storedCountry);
            selectedCurrency = parsedCountry?.currency
        }
    }

    const addToCart = () => {
        const cartItem = {
            id: generateUUID(),
            bestSellerBook: bookData,
            quantity: qty,
            variantType: getVariant(),
            leatherType: activeLeather.value,
            color: selectedColor?.colorName || "",
            itemPrice: getItemPrice(bookData, activeLeather.value)
        };

        const itemValue = getItemPrice(bookData, activeLeather.value)

        window.gtag("event", "add_to_cart", {
            currency: selectedCurrency,
            value: itemValue,
            items: [
                {
                    item_id: bookData?.sku || "",
                    item_name: bookData?.title || "",
                    item_variant: getVariant() || "",
                    price: itemValue || 0,
                    quantity: qty,
                    // Include other properties if available in your data
                    item_category: "Best Seller Books",
                    item_brand: "Rare Biblio", // Replace with actual brand if available
                    leather_type: activeLeather.name, // Using leather type as a category
                    item_color: selectedColor?.colorName
                }
            ]
        });

        if (currentUser?.id) {
            addBestSellerCartItem(bookData, qty, getVariant(), activeLeather.value, selectedColor?.colorName, dispatch)
            dispatch(setIsOpen(true));
        }
        else {
            // history.push(urls.LOGIN, { from: history.location.pathname + history.location.search });
            const cart = JSON.parse(localStorage.getItem("guestCart")) || [];
            if (cart?.length > 0) {
                const isBookInCart = cart?.some(
                    (item) =>
                        item?.bestSellerBook?.sku === bookData?.sku &&
                        item?.leatherType === activeLeather.value &&
                        item?.color === selectedColor?.colorName
                );

                if (isBookInCart) {
                    //update quantity
                    const updatedCart = cart.map((item) =>
                        item?.bestSellerBook?.sku === bookData?.sku &&
                            item?.leatherType === activeLeather.value &&
                            item?.color === selectedColor?.colorName
                            ? { ...item, quantity: item?.quantity + qty }
                            : item
                    );

                    localStorage.setItem("guestCart", JSON.stringify(updatedCart));
                    dispatch(CartActions.addCartItemSuccess(updatedCart));
                    dispatch(setIsOpen(true));
                    return;
                }
            }
            cart.push(cartItem);
            localStorage.setItem("guestCart", JSON.stringify(cart));

            dispatch(CartActions.addCartItemSuccess(JSON.parse(localStorage.getItem("guestCart"))));
            dispatch(setIsOpen(true));
        }
    };

    const scrollRef = useScrollToTop();

    useEffect(() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }, [bookData]);

  
    const updateImagesBasedOnBookData = () => {
      let newImages = []; // Create an empty array

      if (!selectedColor || allowedColors?.length === 0) {
        const colorKeys = Object.keys(JSON.parse(bookData?.images || "{}")).map(key => key.split('_')[0]); // Extract color names
        const defaultColors = allColorsData?.filter(c => colorKeys.includes(c.colorName)); 
        if(defaultColors) {
            newImages = [
                defaultColors?.[0]?.baseImg,
                defaultColors?.[0]?.sideImg1,
                defaultColors?.[0]?.sideImg2,
                defaultColors?.[0]?.sideImg3,
                defaultColors?.[0]?.sideImg4,
            ];

            defaultColors?.forEach((defaultColor) => {
                const key = `${defaultColor?.colorName}_${defaultColor?.leatherType}`;

                if (doesKeyExist(bookData.images, key)) {

                    const imageObj = JSON.parse(bookData?.images);
                    const matchedKey = Object.keys(imageObj).find(
                        (existingKey) => existingKey.toLowerCase() === key.toLowerCase()
                    );
                    const bookImages = JSON.parse(bookData?.images)[matchedKey]?.links;

                    // Update the newImages array with images from bookData
                    newImages = newImages.map((img, index) =>
                        bookImages[index] !== "" ? bookImages[index] : img
                    );
                    setSelectedColor(defaultColor);
                    return;
                }
            })
        }
      } else {
        newImages = [
          selectedColor?.baseImg,
          selectedColor?.sideImg1,
          selectedColor?.sideImg2,
          selectedColor?.sideImg3,
          selectedColor?.sideImg4,
        ];
      }
  
      // If bookData has images and the key exists, update the images based on the key
      if (bookData && bookData.images && selectedColor && activeLeather) {
        const key = `${selectedColor?.colorName}_${activeLeather?.value}`;
  
        if (doesKeyExist(bookData.images, key)) {

            const imageObj = JSON.parse(bookData?.images);
            const matchedKey = Object.keys(imageObj).find(
                (existingKey) => existingKey.toLowerCase() === key.toLowerCase()
              );
          const bookImages = JSON.parse(bookData?.images)[matchedKey]?.links;
  
          // Update the newImages array with images from bookData
          newImages = newImages.map((img, index) =>
            bookImages[index] !== "" ? bookImages[index] : img
          );
        }
      }
  
      // Finally, update the state with the populated images array
      setImages(newImages);
      // Set the current photo to the first image
      if (newImages.length > 0) {
        setCurrentPhoto(newImages[0]);
        setCurrentPhotoIndex(0); // Reset photo index to 0 when images update
      }
    };

    useEffect(() => {
      if (bookData) {
        updateImagesBasedOnBookData();
      }
    }, [bookData, selectedColor, activeLeather, activeVariant]);

     useEffect(() => {
          if(bookData?.sku) {
            window.gtag("event", "view_item", {
              currency: selectedCurrency,
              value: bookData?.priceGenuine,
              items: [
                  {
                      item_id: bookData?.sku || "",
                      item_name: bookData?.title || "",
                      item_variant: activeVariant?.name || "",
                      price: bookData?.priceGenuine || 0,
                      quantity: qty,
                      // Include other properties if available in your data
                      item_category: "Best Seller Books",
                      item_brand: "Rare Biblio", // Replace with actual brand if available
                      leather_type: activeLeather?.name, // Using leather type as a category
                      item_color: selectedColor?.colorName
                  }
              ]
          });
      
          }
        },[bookData])
  
    // Update the current photo whenever the currentPhotoIndex changes
    useEffect(() => {
      if (images.length > 0) {
        setCurrentPhoto(images[currentPhotoIndex]);
      }
    }, [currentPhotoIndex, images]);
  
    function doesKeyExist(jsonString, keyToCheck) {
        if (jsonString) {
          const imagesObj = JSON.parse(jsonString);
          const lowerCaseKeyToCheck = keyToCheck.toLowerCase();
          return Object.keys(imagesObj).some(
            (key) => key.toLowerCase() === lowerCaseKeyToCheck
          );
        }
        return false;
      }

      const handleImageLoad = () => {
        const img = imgRef.current;

        if (img) {
            const { naturalWidth, naturalHeight } = img;
            const container = img.parentElement;
            const containerWidth = container.offsetWidth;
            const containerHeight = container.offsetHeight;

            const widthScale = containerWidth / naturalWidth;
            const heightScale = containerHeight / naturalHeight;
            const scale = Math.min(widthScale, heightScale);

            const imgWidth = naturalWidth * scale;
            const imgHeight = naturalHeight * scale;

            const leftOffset = (containerWidth - imgWidth) / 2;
            const topOffset = (containerHeight - imgHeight) / 2;

            // Position the ribbon relative to the image
            setRibbonStyle({
                top: `${topOffset + 0.05 * imgHeight}px`, // 5% from top of the image
                left: `${leftOffset-4}px`, // Align to image start
            });
        }
    };

    const handleWishListAdd = () => {
        if(currentUser?.id){
          addWishlistItem(bookData,1,dispatch,true)
        }
        else{
            history.push(urls.LOGIN, { from: history.location.pathname + history.location.search });
        }
        
      }

    const handleRemoveFromWishlist = (item) => {
        deleteWishlistItem(item,dispatch)
    }

  const isWishListItem = () => {
    const bookOpt = wishlist?.find((item) => item?.book?.sku === bookData?.sku && item?.book?.title === bookData?.title)
    if(bookOpt) {
      return {isPresent : true, data: bookOpt}
    } else {
      return {isPresent : false, data:null}
    }
  }

  const handleHeartClick = () => {
    if(!isWishListItem().isPresent) {
        handleWishListAdd()
    } else {
        handleRemoveFromWishlist(isWishListItem().data)
    }
  }

  const { original, discounted } = getBookPrice(bookData);
    
    return (
        <>
        {notAvailable ? <Error410Page /> : (
                    <div className={classes.container} ref={scrollRef}>
            <Header />
            {bookData && (
                <>
                    <SEO
                        keywords={bookData?.metaKeywords}
                        title={bookData?.metaTitle || bookData?.title}
                        description={bookData?.metaDescription}
                        canonicalUrl={bookData?.canonicalUrl}
                    />
                </>
            )}
            <div className={classes.mainContainer}>
                <div className={classes.crumb}>
                    <BreadCrumb className={classes.crumb} crumbs={crumbs} />
                </div>

                <div className={classes.productDetails}>
                        <div className={classes.imageSection} onTouchStart={onTouchStart}
                            onTouchMove={onTouchMove}
                            onTouchEnd={onTouchEnd} >
                        <div className={classes.mainImage}>
                            <img ref={imgRef} src={currentPhoto} alt="" onLoad={handleImageLoad}/>
                            <div className={classes.arrowLeft} onClick={handleLeftArrowClick} >
                                <FontAwesomeIcon icon={faAngleLeft} className={classes.leftIcon} />
                            </div>
                            <div className={classes.arrowRight} onClick={handleRightArrowClick}>
                                <FontAwesomeIcon icon={faAngleRight} className={classes.rigthIcon} />
                            </div>
                            <div className={classes.wishlistHeart} onClick={handleHeartClick}>
                                <FontAwesomeIcon icon={isWishListItem().isPresent ? faHeartFull : faHeart} />
                            </div>
                            <div className={classes.ribbon} style={ribbonStyle}>
                                <img src={bestSellerRibbon} alt="" />
                            </div>
                        </div>
                        <div className={classes.images}>
                            {images?.filter(image => image && image !== "")?.map((image, index) => (
                                <img key={index} src={image} alt="" onClick={() => setCurrentPhoto(image)} className={currentPhoto === image ? classes.activeImage : ""} />
                            ))}
                        </div>
                    </div>
                    <div className={classes.details}>
                        <h1>{bookData?.title}</h1>
                        <div className={classes.authors}>
                                <h2>{bookData?.author}</h2>
                        </div>

                        <h3>
                            {discounted ? (
                                <>
                                    <span style={{ marginRight: "8px" }}>{`${selectedCurrency} ${discounted}`}</span>
                                    <span style={{ textDecoration: "line-through", color: "grey", fontSize: "1rem" }}>
                                        {`${selectedCurrency} ${original}`}
                                    </span>
                                </>
                            ) : (
                                `${selectedCurrency} ${original}`
                            )}
                        </h3>
                        
                        <div className={classes.varientTypes}>
                            <div className={classes.varientHeader}>
                                <h2>Leather Types</h2>
                                <p style={{cursor:"pointer"}} onClick={() => {setShowLeatherType(true);setQty(1)}} >Know about Leather &gt;</p>
                            </div>
                            <div className={classes.leatherTypeBtn}>
                                {LeatherTabs.map((type, index) => (
                                    <div
                                        className={`${classes.leatherBtn} ${activeLeather.name === type.name ? classes.activeleatherBtn : ""}`}
                                        onClick={() => handleSetActiveLeather(type)}
                                        key={index}
                                    >
                                        <p>{type.name}</p>
                                    </div>

                                ))}
                            </div>
                        </div>

                        {allowedColors?.length > 0 && <div className={classes.selectColor}>
                            <h2>Color : {selectedColor?.colorName}</h2>
                            <div className={classes.colors}>
                                {allowedColors?.map((color, index) => (
                                    <div key={index} className={`${classes.colorPicker} ${selectedColor?.colorName === color.colorName ? classes.active : ""}`} onClick={() => {
                                            setSelectedColor(color)
                                            setQty(1)
                                        }}>
                                        <img src={color.paletteImage} alt="" />
                                        {/* <p>{color.colorName}</p> */}
                                    </div>
                                ))}
                            </div>
                        </div>}

                        <div className={classes.quantityContainer}>
                            <h2>Quantity</h2>
                            <div className={classes.quantity}>
                                <div className={classes.selectQty}>
                                    <div className={classes.qtyButton} onClick={handleQtyDecrease}><p>-</p></div>
                                    <h2>{qty}</h2>
                                    <div className={classes.qtyButton} onClick={handleQtyIncrease}><p>+</p></div>
                                </div>
                                <SecondaryButton className={classes.addToCart} onClick={addToCart}>Add to Cart</SecondaryButton>
                            </div>
                        </div>

                    </div>
                </div>

                <div className={classes.bindingFeatures}>
                    <h2 className={classes.featuresHeading}>About the Binding</h2>
                    {isSmallScreen && <p>Slide to view more features <FontAwesomeIcon icon={faArrowRight}/></p> }
                    <div className={classes.featureSection}>
                        {features.map((data, index) => (
                            <div key={index} className={classes.features}>
                                <FeatureCard key={index} image={data.image} title={data.title} />
                            </div>
                        ))}
                    </div>
                </div>

                <div className={classes.mainBody}>
                    <div className={classes.tabs}>
                        {tabsData.map((tab, index) => (
                            <div
                                key={tab}
                                className={`${classes.tab} ${activeTab === index ? classes.activeTab : ''}`}
                                onClick={() => setActiveTab(index)}
                            >
                                <p>{tab}</p>
                            </div>
                        ))}
                    </div>
                    {activeTab === 0 ? (
                        <AboutBook pages={bookData?.pages} author={bookData?.author} publicationDate={bookData?.publishingYear} language={bookData?.language} title={bookData?.title} desc={bookData?.description} sku={bookData?.sku}
                        isbnNo={bookData?.isbnNo} genres={bookData?.genres} />
                    ) : (
                        <div>
                            <Reviews bookData={{...bookData,imageUrl:currentPhoto}}/>
                        </div>
                    )}
                </div>

                <div className={classes.recommendation}>
                    <Recommendations book={bookData}/>
                </div>


            </div>
            <Footer />

            {showLeatherType && <LeatherType onClose={() => setShowLeatherType(false)} />}
            {showVariantType && <VariantType onClose={() => setShowVariantType(false)} />}
        </div>
        )}

        </>
    )
}

export default BestSellerPDP;
